/**
 * Created by Mark on 18/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    MAKE_HOMEWORK : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/make',
    ON_HOMEWORK_MADE :  'ON_HOMEWORK_MADE',
    SET_LANGUAGE : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setLanguage',
    SET_TYPE: ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setType',
    SET_CATALOG: ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setCatalog',
    SET_VOCABULARY_GAMES : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setVocabularyGames',
    SET_NAME : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setName',
    SET_DATES : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setDates',
    SET_ASSIGN : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setAssign',
    SET_PUBLISHED : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/setComplete',
    GET_ALL_HOMEWORK : ENVIRONMENT_CONSTANTS.BASE_URL + '/assignmentController/getViewable',
    ON_VIEWABLE_HOMEWORK_FETCH:'ON_VIEWABLE_HOMEWORK_FETCH',
}



// WEBPACK FOOTER //
// ./src/constants/homework.js